import { useCallback, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { BookingInsurance, INSURANCE_TYPE_LABEL } from "src/store/reducers/bookings";
import AddInsuranceBookingCanvas from "./AddInsuranceBookingCanvas";
import EditInsuranceBookingCanvas from "./EditInsuranceBookingCanvas";

interface ListBookingInsurancesProps {
  bookingId: string;
  bookingInsuranceData: BookingInsurance[];
  setDeleteInsuranceId: React.Dispatch<React.SetStateAction<string | undefined>>;
}

function ListBookingInsurances({
  bookingId,
  bookingInsuranceData,
  setDeleteInsuranceId,
}: ListBookingInsurancesProps) {
  const [editInsuranceId, setEditInsuranceId] = useState<number>();
  const [showInsuranceAddModal, setShowInsuranceAddModal] = useState(false);
  const [show, setShow] = useState(bookingInsuranceData.length > 0);
  const toggleShow = useCallback(() => {
    setShow((show) => !show);
  }, []);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-xxl-12">
            <div className="card h-auto">
              <div className="card-header">
                <h4
                  className="heading mb-0 link"
                  role="button"
                  onClick={toggleShow}
                >
                  {show ? (
                    <span className="btn-icon-start">
                      <i className="fa fa-minus color-info"></i>
                    </span>
                  ) : (
                    <span className="btn-icon-start">
                      <i className="fa fa-plus color-info"></i>
                    </span>
                  )}
                  Insurances
                </h4>
                <Link
                  to={"#"}
                  className="btn btn-primary btn-sm"
                  data-bs-toggle="offcanvas"
                  onClick={() => setShowInsuranceAddModal(true)}
                >
                  + Add Insurance
                </Link>
              </div>
              <div className={!show ? "card-body d-none" : "card-body"}>
                {bookingInsuranceData?.length > 0 ? (
                  <div className="table-responsive active-projects">
                    <div
                      id="projects-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="projects-tbl"
                        className="table table-hover dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th>Insurance Provider</th>
                            <th>Policy Number</th>
                            <th>Insurance Type</th>
                            <th>Coverage Amount</th>
                            <th>Premium Amount</th>
                            <th>Advance Paid</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bookingInsuranceData?.map((insuranceData, index) => (
                            <tr key={insuranceData.id}>
                              <td>
                                {insuranceData.insurance_provider?.provider_name}
                              </td>
                              <td>{insuranceData.policy_number}</td>
                              <td>
                                {INSURANCE_TYPE_LABEL[insuranceData.insurance_type]}
                              </td>
                              <td>{insuranceData.coverage_amount || "-"}</td>
                              <td>{insuranceData.premium_amount}</td>
                              <td>{insuranceData.advance_amount_paid || "-"}</td>
                              <td>
                                <NavLink
                                  className="btn btn-primary shadow btn-xs sharp me-1"
                                  onClick={() => setEditInsuranceId(index)}
                                  to={`#`}
                                  title="Edit"
                                >
                                  <i className={`fas fa-pen`} />
                                </NavLink>{" "}
                                <NavLink
                                  className="btn btn-danger shadow btn-xs sharp"
                                  onClick={() => {
                                    setDeleteInsuranceId(insuranceData.id);
                                  }}
                                  to={`#`}
                                  title="Delete"
                                >
                                  <i className={`fas fa-x`} />
                                </NavLink>{" "}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    &nbsp;
                    <strong>Add insurances for this booking </strong>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddInsuranceBookingCanvas
        Title={"Add Insurance"}
        show={showInsuranceAddModal}
        bookingId={bookingId}
        setShow={setShowInsuranceAddModal}
      />
      <EditInsuranceBookingCanvas
        editId={
          typeof editInsuranceId !== "undefined"
            ? bookingInsuranceData?.[editInsuranceId]?.id
            : ""
        }
        Title={"Edit Insurance"}
        bookingId={bookingId}
        data={
          typeof editInsuranceId !== "undefined"
            ? bookingInsuranceData?.[editInsuranceId]
            : undefined
        }
        hide={() => setEditInsuranceId(undefined)}
      />
    </>
  );
}

export default ListBookingInsurances;
